import { Props as ItemProps } from "./Item"

export interface Item extends Omit<
  ItemProps,
  | "isAdmin"
  | "isEditor"
  | "isSocials"
  | "isExpanded"
  | "isShowSubItems"
  | "onSetOpenSubItems"
> {
  isAdmin?: boolean
  isEditor?: boolean
  isSocials?: boolean
}

const items: Item[] = [
  {
    iconGroup: "fa6",
    iconName: "FaHouse",
    isEditor: true,
    isSocials: true,
    label: "Home",
    link: "/"
  },
  {
    iconGroup: "fa6",
    iconName: "FaRegFileLines",
    isEditor: true,
    label: "Home Video Reviews",
    link: "/home-video-reviews",
    subItems: [
      { isEditor: true, label: "Add", link: "/home-video-reviews/add" },
      { label: "Edit", link: "/home-video-reviews/edit" },
      {
        label: "Single Add",
        link: "/home-video-reviews/single-add"
      }
    ]
  },
  {
    iconGroup: "fa6",
    iconName: "FaRegNewspaper",
    isEditor: true,
    label: "News",
    link: "/news",
    subItems: [
      { isEditor: true, label: "Add", link: "/news/add" },
      { label: "Edit", link: "/news/edit" },
      { isEditor: true, label: "Outlets", link: "/news/outlets" }
    ]
  },
  {
    iconGroup: "fa6",
    iconName: "FaRegBookmark",
    isEditor: true,
    label: "Drafts",
    link: "/drafts",
    subItems: [
      {
        isEditor: true,
        label: "Home Video Reviews",
        link: "/drafts/home-video-reviews"
      },
      { isEditor: true, label: "News", link: "/drafts/news" }
    ]
  },
  {
    iconGroup: "fa6",
    iconName: "FaCompactDisc",
    isEditor: true,
    label: "Home Videos",
    link: "/home-videos/home-videos"
  },
  {
    iconGroup: "fa6",
    iconName: "FaShareFromSquare",
    isSocials: true,
    label: "Socials",
    link: "/socials",
    subItems: [
      {
        isSocials: true,
        label: "Generate Posts",
        link: "/socials/generate-posts"
      },
      { label: "Ai Instructions", link: "/socials/ai-instructions" },
      {
        isSocials: true,
        label: "Prospects",
        link: "/socials/prospects"
      }
    ]
  },
  {
    iconGroup: "fa6",
    iconName: "FaBuilding",
    isEditor: true,
    label: "Vendors",
    link: "/vendors",
    subItems: [
      { isEditor: true, label: "Labels", link: "/vendors/labels" },
      { isEditor: true, label: "Stores", link: "/vendors/stores" },
      { isEditor: true, label: "Vendors", link: "/vendors/vendors" }
    ]
  },
  {
    iconGroup: "fa6",
    iconName: "FaRegEnvelope",
    label: "E-Mails",
    link: "/emails",
    subItems: [
      { label: "Headings", link: "/emails/headings" },
      { label: "Footers", link: "/emails/footers" },
      { label: "Templates", link: "/emails/templates" }
    ]
  },
  {
    iconGroup: "fa6",
    iconName: "FaTrophy",
    label: "Contests",
    link: "/contests"
  },
  {
    iconGroup: "fa6",
    iconName: "FaRegCommentDots",
    label: "Forum",
    link: "/forum",
    subItems: [
      { label: "Categories", link: "/forum/categories" },
      { label: "Sections", link: "/forum/sections" }
    ]
  },
  {
    iconGroup: "fa6",
    iconName: "FaEnvelopeOpenText",
    label: "Newsletters",
    link: "/newsletters"
  },
  {
    iconGroup: "fa6",
    iconName: "FaRegMap",
    label: "Eight Legged Freak",
    link: "/eightleggedfreak",
    subItems: [
      { label: "News", link: "/eightleggedfreak/news" },
      { label: "Reviews", link: "/eightleggedfreak/reviews" }
    ]
  },
  {
    iconGroup: "fa6",
    iconName: "FaBlog",
    label: "Blog",
    link: "/blog",
    subItems: [{ label: "Roundup", link: "/blog/roundup" }]
  },
  {
    iconGroup: "fa6",
    iconName: "FaRegImages",
    label: "Images Grid",
    link: "/images-grid"
  },
  {
    iconGroup: "fa6",
    iconName: "FaFilm",
    label: "Movies and Shows",
    link: "/moviesandshows",
    subItems: [
      { label: "Movies", link: "/moviesandshows/movies/add" },
      { label: "TV Shows", link: "/moviesandshows/shows" }
    ]
  }
]

export default items
